const strings = {
    phone_number_0800: "0800 888 3554",
    terms_and_cond: "https://terminos.ellie.care/?_gl=1*1ez4e9r*_ga*MTExNDU3MjIxOC4xNzEzODc3MTA0*_ga_04WBQQV4M0*MTcxNDE1ODA4My42LjAuMTcxNDE1ODA4My4wLjAuMA..*_ga_H27VFT2BQ7*MTcxNDE1ODA4My43LjAuMTcxNDE1ODA4My42MC4wLjA.*_gcl_au*NzUwNTkzNTgzLjE3MTM4NzcxMDQ.",
    priv_policy: "https://politicas.ellie.care/?_gl=1*1iu96qh*_ga*MTgwNTgyMTE3LjE3MTU3Nzg4Mjk.*_ga_04WBQQV4M0*MTcxNjE1Mjc2Mi41LjEuMTcxNjE1MjgxNi4wLjAuMA..*_gcl_au*MTUwNjEwMDEzMy4xNzE1Nzc4ODI5*_ga_H27VFT2BQ7*MTcxNjE1Mjc2Mi41LjEuMTcxNjE1MjgxNi42LjAuMA..",
    whatsapp_number: "+5491169963554",
    whatsapp_message: "Hola, quiero pedir más información sobre Ellie Care.",
    linkedin: "https://www.linkedin.com/company/ellie-care/",
    instagram: "https://www.instagram.com/elliecare.latam/",
    facebook: "https://www.facebook.com/elliecare.latam",
}

export default strings;
